import axios from "axios";
import Base from "../layout/BaseTemplate";
import React, { useState } from "react";
import { useEffect } from "react";

import {
    Table,
} from "react-bootstrap";

export default function Tutorial() {
    const [files, setFiles] = useState([]);
    const [header, setHeader] = useState(``);

    function getFiles() {
        axios({
            method: "GET",
            url: "/tutorials/files"
        }).then((res) => {
            setFiles(res.data[0]);
            setHeader(res.data[1]);
        }).catch((err) => {
            console.log(err)
        })
    }

    function downloadFile(fileName) {
        axios({
            method: "GET",
            url: `/tutorials/files/${fileName}`,
            responseType: 'blob'
        }).then((res) => {
            const blob = new Blob([res.data], { type: res.data.type });
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName; // The file will be downloaded with its name
            link.click();
            window.URL.revokeObjectURL(url); // Clean up
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getFiles();
    }, [])

    return (
        <Base>
            <div >
                <div className="centerText" dangerouslySetInnerHTML={{ __html: header }}>
                </div>
                <br />

                {files.length > 0 ? (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Last Modified</th>
                                <th>Size</th>
                            </tr>
                        </thead>
                        <tbody>
                            {files.map((item) => (
                                <tr style={{ cursor: "pointer" }} key={item.name} onClick={() => downloadFile(item.name)}>
                                    <td>
                                        {item.type === 'directory' ? (
                                            <div>
                                                <i className="bi bi-folder"></i> {item.name}
                                            </div>
                                        ) : (
                                            <div>
                                                <i className="bi bi-file-earmark"></i> {item.name}
                                            </div>
                                        )}
                                    </td>
                                    <td>{item.last_modified}</td>
                                    <td>{item.size}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : <h2 className="centerText">No Files Found!</h2>}

            </div>
        </Base>
    )
}

